import api from "./api";

export async function startCheckout({ lookup_key, quantity = 1, user_id = null }) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    quantity,
    origin_url: window.location.origin,
    user_id,
  });
  if (data.checkout_url) {
    window.location.href = data.checkout_url;
  }
  return data;
}

export function formatPrice(amount, currency = "cad") {
  return new Intl.NumberFormat("fr-CA", { style: "currency", currency: currency.toUpperCase() }).format(amount);
}
